const reducer = (state, action) => {
    switch (action.type) {
        case 'SET_SELECTION':
            return {
                ...state,
                fieldList: [...state.fieldList, action.payload]
            }
            default:
                return state;
    }
}
export default reducer;